import "./index.css";

// Import all portfolio components
import Banner from "./components/Banner";
import Hero from "./components/Hero";
import Statistics from "./components/Statistics";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";

export function App() {
  return (
    <div className="min-h-screen w-full overflow-x-hidden">
      <Banner />
      <Hero />
      <Statistics />
      <Skills />
      <Experience />
      <ContactForm />
      <Footer />
    </div>
  );
}

export default App;
